<template>
  <v-sheet class="pa-4 package-sheet" :color="pkg.LandingPageColor">
    <v-row v-if="pkg.BadgeText">
      <v-chip class="ma-2" color="#BEE3FF" label>
        <v-icon left color="#0B5289">
          mdi-tag-outline
        </v-icon>
        <span class="tempo-badge">{{ pkg.BadgeText }}</span>
      </v-chip>
    </v-row>
    <v-row>
      <v-col class="package-header" cols="12">
        <h2
          :class="{
            'package-title': true,
            'white--text': pkg.LandingPageTextColor == 'light'
          }"
        >
          {{ pkg.Title }}
        </h2>
        <h2
          :class="{
            'package-price': true,
            'white--text': pkg.LandingPageTextColor == 'light'
          }"
        >
          {{ pkg.Price | toCurrency }}
        </h2>
      </v-col>
    </v-row>
    <v-row class="package-dates-row">
      <v-col class="package-dates-col" cols="12">
        <v-divider class="my-3 package-divider"></v-divider>
        <v-row>
          <v-col cols="12" md="4">
            <div
              :class="{
                'tempo-subtitle': pkg.LandingPageTextColor != 'light',
                'tempo-subtitle-light': pkg.LandingPageTextColor == 'light'
              }"
            >
              Date(s)
            </div>
            <div
              :class="{
                'white--text': pkg.LandingPageTextColor == 'light',
                'my-2': true
              }"
            >
              <h3 v-for="d in pkg.Dates" :key="d.DateID">
                {{ d.Date | toDateWithTime }}
              </h3>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row v-if="pkg.isOnSale">
      <v-col class="package-dates-col" cols="12">
        <v-btn depressed color="primary" :to="pkg.BookingUrl">Select</v-btn>
      </v-col>
    </v-row>
  </v-sheet>
</template>
<script>
export default {
  props: ["pkg"]
};
</script>
<style scoped>
.tempo-subtitle {
  color: #919699;
  font-size: 15px;
}
.tempo-subtitle-light {
  color: #d3e3eb;
  font-size: 15px;
}
.tempo-badge {
  color: #0b5289;
}

.package-sheet {
  width: 80%;
  border: 1px solid black !important;
}

.package-header {
  display: flex;
}
.package-title {
  flex: 1;
  width: 80%;
  justify-content: flex-start;
}
.package-price {
  display: flex;
  justify-content: flex-end;
}
.package-dates-col {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
.package-divider {
  margin-top: 6px !important;
  margin-bottom: 8px !important;
}
.package-sheet .row:last-child {
  margin-top: 0;
  margin-bottom: 4px !important;
}

/* Mobile styling */
@media (max-width: 600px) {
  .package-sheet {
    width: 100%;
  }
}
</style>
